let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1pfpB")).then(() => parcelRequire('3kTyx'));